import { Question, LanguageDictionaryFactory, Answer, EndResult } from "./question.model";

export class QuestionFlow {
  private questionConfig: any;
  private questions: Question[];
  constructor(private sourceConfig: any) {
    this.questionConfig = sourceConfig.default;
    this.buildTree();
  }

  start(): Question {
    return this.questionResolver("P1");
  }
  end(): Question {
    return this.questionResolver("E1");
  }

  private buildTree() {
    if (!this.questionConfig) { return; }
    this.questions = Object.entries(this.questionConfig).map(([k, v]) => {
      const value = v as any;
      const code = k as string;
      const q = new Question();
      q.Code = code;
      q.Type = value.type;
      if (value.title) {
        q.Title = LanguageDictionaryFactory(value.title);
      }
      q.Text = LanguageDictionaryFactory(value.text);
      q.Info = LanguageDictionaryFactory(value.info);
      if (value.next) {
        q.Next = () => this.questionResolver(value.next);
      }
      if (value.preText) {
        q.PreText = LanguageDictionaryFactory(value.preText);
      }
      if (value.footnote) {
        q.FootNote = LanguageDictionaryFactory(value.footnote);
      }
      if (value.answers && value.answers.length > 0) {
        q.Answers = (value.answers).map((item: any) => {
          const r = new Answer();
          r.Code = item.code;
          r.Text = LanguageDictionaryFactory(item.text);
          r.DestinationCode = item.destination;
          r.DestinationResolver = () => this.questionResolver(item.destination);
          return r;
        });
      }
      return q;
    });
  }

  private questionResolver(code: string): Question {
    const qn = this.questions.filter(x => x.Code === code);
    if (qn.length > 0) {
      return qn[0];
    } else {
      const a = new Question();
      a.Code = code;
      return a;
    }
  }

}